module.exports = __webpack_public_path__ + "img/jjdcjd.ac6d6c56.png";